"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = { class: "login-home" };
const _hoisted_2 = ["href"];
const _hoisted_3 = ["href"];
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
        (_ctx.user !== undefined)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)(vue_1.Fragment, { key: 0 }, [
                (0, vue_1.createTextVNode)(" You are " + (0, vue_1.toDisplayString)(_ctx.user) + " ", 1),
                (0, vue_1.createElementVNode)("a", { href: _ctx.logoutURL }, "Log out", 8, _hoisted_2)
            ], 64))
            : ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("a", {
                key: 1,
                href: _ctx.loginUrl
            }, [...(_cache[0] || (_cache[0] = [
                    (0, vue_1.createElementVNode)("img", {
                        style: { "width": "87px", "height": "24px" },
                        src: "https://cdn.prod.website-files.com/6257adef93867e50d84d30e2/6257d23c5fb25be7e0b6e220_Open%20Source%20Projects%20_%20Discord-7.svg"
                    }, null, -1),
                    (0, vue_1.createTextVNode)(" Login with Discord", -1)
                ]))], 8, _hoisted_3))
    ]));
}
